import { documentsReducer } from '@platform/documents';
import { summaryUiReducer } from '@platform/summary-ui';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import chatQueueReducer from '../platform/chat/state/chatQueueSlice';
import timelineReducer from '../platform/timeline/state/timelineSlice';
import { setAppStore } from '../services/tokenService';
import './api/analyticsApi';
import { apiSlice } from './api/apiSlice';
import { rpcSlice } from './api/rpcSlice';
import authReducer from './auth/authSlice';

export const makeStore = () => {
  const storeInstance = configureStore({
    reducer: {
      api: apiSlice.reducer,
      rpc: rpcSlice.reducer,
      auth: authReducer,
      documents: documentsReducer,
      timeline: timelineReducer,
      chatQueue: chatQueueReducer,
      summaryUi: summaryUiReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware, rpcSlice.middleware),
  });
  return storeInstance;
};

export const store = makeStore();
setupListeners(store.dispatch);

// Inject the store instance into tokenService to avoid import cycles
setAppStore(store);

if (import.meta.env.DEV && typeof window !== 'undefined') {
  (window as any).__appStore = store;
  (window as any).__apiSlice = apiSlice;
}

// Application root types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
